import { toFkey } from '.'

// TODO.rl: Fix this as its a hack that circumvents the type system.
export const getFkeyFromObject = (T: any): string => {
  return T.fkey || toFkey(T.id)
}
